function prefersReducedMotion() {
	return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

function headerOffset() {
	const header = document.getElementById('header')
	return header ? header.offsetHeight + 8 : 0
}

function viewTop() {
	const header = document.getElementById('header')
	return header ? header.getBoundingClientRect().bottom : 0
}

function focusTarget(target) {
	if (!(target instanceof HTMLElement)) return
	if (!target.hasAttribute('tabindex')) {
		target.setAttribute('tabindex', '-1')
	}
	target.focus({ preventScroll: true })
}

function smoothScrollTo(hash) {
	if (!hash || hash === '#') return
	const target = document.querySelector(hash)
	if (!target) return

	const top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset()

	if (prefersReducedMotion()) {
		window.scrollTo(0, top)
	} else {
		window.scrollTo({ top, behavior: 'smooth' })
	}

	focusTarget(target)
	history.pushState(null, '', hash)
}

document.addEventListener('click', (event) => {
	const link = event.target.closest('a.js-nav-link, a[href^="#"]')
	if (!link) return

	const href = link.getAttribute('href')
	if (!href || href === '#' || !href.startsWith('#')) return
	if (!document.querySelector(href)) return

	event.preventDefault()
	smoothScrollTo(href)
})

/**
 * Each nav label is a horizontal scrollbar for its section:
 * track = the whole section, thumb = the visible slice and its position.
 */
function initScrollSpy() {
	const links = Array.from(document.querySelectorAll('.header__nav-link'))
	if (!links.length) return

	const items = links
		.map((link) => {
			const id = link.getAttribute('href')
			const el = id ? document.querySelector(id) : null
			const thumb = link.querySelector('.header__nav-progress-thumb')
			return el && thumb ? { link, el, thumb } : null
		})
		.filter(Boolean)

	if (!items.length) return

	const minThumb = 0.12
	let ticking = false

	const update = () => {
		const topBound = viewTop()
		const bottomBound = window.innerHeight
		let best = null
		let bestVisible = 0

		for (const item of items) {
			const rect = item.el.getBoundingClientRect()
			const height = rect.height
			const visTop = Math.max(topBound, rect.top)
			const visBottom = Math.min(bottomBound, rect.bottom)
			const visible = Math.max(0, visBottom - visTop)
			const intersecting = visible > 1 && height > 0

			let start = 0
			let size = 0

			if (intersecting) {
				start = (visTop - rect.top) / height
				size = visible / height

				if (size < minThumb) {
					const center = start + size / 2
					size = minThumb
					start = Math.min(1 - size, Math.max(0, center - size / 2))
				}
			}

			item.thumb.style.transform = `translate3d(${start * 100}%, 0, 0) scaleX(${size})`
			item.link.classList.toggle('is-in-view', intersecting)

			if (visible > bestVisible) {
				bestVisible = visible
				best = item
			}
		}

		for (const item of items) {
			const active = item === best && bestVisible > 0
			item.link.classList.toggle('is-active', active)
			if (active) {
				item.link.setAttribute('aria-current', 'location')
			} else {
				item.link.removeAttribute('aria-current')
			}
		}
	}

	const onScroll = () => {
		if (ticking) return
		ticking = true
		requestAnimationFrame(() => {
			ticking = false
			update()
		})
	}

	update()
	window.addEventListener('scroll', onScroll, { passive: true })
	window.addEventListener('resize', onScroll, { passive: true })
}

document.addEventListener('DOMContentLoaded', initScrollSpy)
